import {BussinessLine, type BussinessLineData} from "@/types/site_admin/bussiness-lines";

export class Branch {
    public id: number | null;
    public code: string;
    public name: string;
    public is_enabled: boolean;
    public businessLines: BussinessLine[];

    constructor(data: BranchData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.code = "";
            this.name = "";
            this.is_enabled = false;
            this.businessLines = [];
        } else {
            this.id = data.id;
            this.code = data.code;
            this.name = data.name;
            this.is_enabled = data.is_enabled;
            this.businessLines = [];
            if (data.businessLines !== undefined) {
                data.businessLines.forEach(businessLine => this.businessLines.push((new BussinessLine(businessLine))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false): BranchData {
        const serialized_data: BranchData = {
            id: this.id,
            code: this.code,
            name: this.name,
            is_enabled: this.is_enabled,
        }

        if (without_relations === false ||
            (Array.isArray(without_relations) && !without_relations.includes('businessLines'))
        ) {
            serialized_data.businessLines = [];
            this.businessLines.forEach(businessLine => {
                serialized_data.businessLines.push(businessLine.serializeData())
            })
        }

        return serialized_data;
    }

    public resetToDefaults(): void {
        this.id = null;
        this.code = "";
        this.name = "";
        this.is_enabled = false;
        this.businessLines = [];
    }
}

export type BranchData = {
    id: number | null;
    code: string;
    name: string;
    is_enabled: boolean;
    businessLines?: BussinessLineData[] | undefined;
}
